export default __webpack_public_path__ + "static/char-55-anr-18639b5365fdab3113e0ac15afaef121.webp";